<div
  class="container-fluid online-menu-wrapper"
  [ngClass]="{ 'online-menu-wrapper-home-page': headerService.isHomePage }"
>
  <div class="social-wrapper">
    <a href="https://www.instagram.com/archonline.co.il/" target="_blank">
        <fa-icon [icon]="faInstagram"></fa-icon>
    </a>

    <a href="https://www.facebook.com/gilarchonline/" target="_blank">
        <fa-icon [icon]="faFacebookSquare"></fa-icon>
    </a>
  </div>
  <div class="row">
    <div
      class="col-md-12 online-menu-wrapper-col"
      id="main-manu"
      [ngClass]="{
        'online-menu-wrapper-col-background': !headerService.isHomePage
      }"
    >
      <div class="row">
        <!-- תפריט ולוגו בדף הבית דסקטופ -->
        <div
          class="logo-home-page-wrapper"
          [ngClass]="{
            'online-menu-wrapper-col-background-anim':
              headerService.isHomePage && headerBckActive,
            'rout-from-other-page': getRoutFromOtherPage() == '1'
          }"
        >
          <!-- לוגו בדף הבית  -->
          <div
            class="logo-home-page"
            routerLink="/"
            (click)="clickLogo()"
            [ngClass]="{
              'logo-home-page-bck':
                headerService.isHomePage &&
                !headerBckActive &&
                getRoutFromOtherPage() != '1'
            }"
          ></div>
          <!-- תפריט בדף הבית  -->
          <div class="col-md-12 menu-home-page">
            <div class="online-menu online-menu-home">
              <a
                class="menu-item-link menu-link-basket"
                routerLink="/aoc/archonline_basket"
              >
                <div
                  class="num-of-orders"
                  [ngClass]="{ 'num-of-orders-active': trnsItems?.length > 0 }"
                >
                  <div>{{ trnsItems.length }}</div>
                </div>
              </a>
              <span *ngFor="let menuItem of menuItems">
                <a
                  routerLink="{{ menuItem.link }}"
                  class="a-tab-menu"
                  *ngIf="menuItem.id == 1 || menuItem.id == 4"
                  class="menu-item-link"
                  [class.order-item]="menuItem.id == 1"
                >
                  <span
                    class="menu-text"
                    [ngClass]="{
                      'order-btn':
                        menuItem.id == 1 &&
                        headerService.currentTab != menuItem.id,
                      'menu-text-not-scroll':
                        headerService.isHomePage &&
                        !headerBckActive &&
                        getRoutFromOtherPage() != '1',
                      'active-tab': headerService.currentTab == menuItem.id
                    }"
                    >{{ menuItem.title }}</span
                  >
                </a>
                <a
                  routerLink="{{ menuItem.link }}"
                  class="a-tab-menu"
                  *ngIf="menuItem.id != 1 && menuItem.id != 4"
                >
                  <span
                    class="menu-text"
                    [ngClass]="{
                      'menu-text-not-scroll':
                        headerService.isHomePage &&
                        !headerBckActive &&
                        getRoutFromOtherPage() != '1',
                      'active-tab': headerService.currentTab == menuItem.id
                    }"
                    >{{ menuItem.title }}</span
                  >
                </a>
              </span>

              <a
                class="menu-item-link menu-link-studio"
                href="http://gilarch.co.il/"
                >סטודיו גיל אדריכלות</a
              >
            </div>
          </div>
        </div>

        <app-header-mobile [menuItems]="menuItems"></app-header-mobile>
      </div>
    </div>
  </div>
</div>
<!-- תפריט שורה שלישית -->
<div
  class="header-row-3"
  [class.coupon-display]="couponService.displayCouponCodeForm"
>
  <app-title
    *ngIf="title != 'none'"
    width="10"
    title="{{ title }}"
    spaceFromRight="1"
  ></app-title>
  <div
    class="stage-list-wrapper"
    *ngIf="step != null || this.headerService.currentTab == 1"
  >
    <div class="stage-list" *ngIf="step != null">
      <div
        [ngClass]="{ 'stgae-active': activeStages[0] }"
        class="stage"
        (click)="backToStageOne()"
      >
        שלב 1
      </div>
      <div [ngClass]="{ 'stgae-active': activeStages[1] }" class="stage">
        שלב 2
      </div>
      <div [ngClass]="{ 'stgae-active': activeStages[2] }" class="stage">
        שלב 3
      </div>
    </div>
    <div *ngIf="this.headerService.currentTab == 1"></div>
    <div
      class="coupon-div"
      *ngIf="step != null || this.headerService.currentTab == 1"
    >
      <app-coupon-btn></app-coupon-btn>
    </div>
  </div>
</div>

<div class="loding-frame" *ngIf="loaderService.showLoader">
  <div class="loading-icon" *ngIf="!loaderService.showWorkingProgress"></div>
  <div class="work-in-progress-frame" *ngIf="loaderService.showWorkingProgress">
    <div
      class="work-in-progress-txt"
      [ngClass]="{
        'hide-workinprogress-txt': loaderService.makeChangeEffect,
        'show-workinprogress-txt': !loaderService.makeChangeEffect
      }"
    >
      {{ loaderService.workInProgressTxt }}
    </div>
    <div class="work-in-progress-load"></div>
    <div class="progress-value">{{ transactionsService.progressBarValue }}%</div>
    <mat-progress-bar
      mode="determinate"
      [value]="transactionsService.progressBarValue"
    >
    </mat-progress-bar>
  </div>
</div>

<app-online-ask-us></app-online-ask-us>

<app-share-this></app-share-this>
<app-side-bar [menuItems]="menuItems"></app-side-bar>
<div
  *ngIf="
    overloadConfig.overloadConfig?.Ivalue == 1 &&
    displayOverLoad.displayOverLoad
  "
  class="overload-msg-wrapper"
>
  <div class="overload-msg">
    <div class="close-overload" (click)="closeOverload()">X</div>
    <div
      class="overload-txt"
      [innerHtml]="overloadConfig.overloadConfig.SValue"
    ></div>
    <div class="overload-btn" (click)="closeOverload()">אישור</div>
  </div>
</div>
<app-upload-files></app-upload-files>
<app-create-coupon-code></app-create-coupon-code>
